module.exports = __webpack_public_path__ + "static/media/budget-tracker.75fdae4a.jpg";